import { LinkTo } from "@ember/routing";
import LoadMore from "discourse/ui-kit/d-load-more";
import dAvatar from "discourse/ui-kit/helpers/d-avatar";
import dFormatDate from "discourse/ui-kit/helpers/d-format-date";
import DConditionalLoadingSpinner from "discourse/ui-kit/d-conditional-loading-spinner";

<template>
  <div class="alert alert-warning">Due to privacy constraints, only emails that
    were sent to 50+ users are displayed.
  </div>
  <LoadMore @selector=".email-list tr" @action={{@controller.loadMore}}>
    <table class="table email-list">
      <thead>
        <tr>
          <th>Post Time</th>
          <th>Post Author</th>
          <th>Post</th>
          <th>Open Rate</th>
        </tr>
      </thead>

      <tbody>
        {{#each @controller.model as |email|}}
          <tr>
            <td class="time">
              {{#if email.post_created_at}}
                {{dFormatDate email.post_created_at}}
              {{else}}
                &mdash;
              {{/if}}
            </td>
            <td class="author">
              {{#if email.post_author}}
                <LinkTo @route="adminUser" @model={{email.post_author}}>
                  {{dAvatar email.post_author imageSize="tiny"}}
                </LinkTo>
                <LinkTo @route="adminUser" @model={{email.post_author}}>
                  {{email.post_author.username}}
                </LinkTo>
              {{else}}
                &mdash;
              {{/if}}
            </td>
            <td>
              {{#if email.post_url}}
                <a href={{email.post_url}}>{{email.post_description}}</a>
              {{else}}
                <span>{{email.post_description}}</span>
              {{/if}}
            </td>
            <td class="count">{{email.opened}}/{{email.sent}}
              ({{email.open_rate}})
            </td>
          </tr>
        {{else}}
          <tr>
            <td colspan="4">
              None
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </LoadMore>

  <DConditionalLoadingSpinner @condition={{@controller.loading}} />
</template>
